import { defineComponent, onMounted, onBeforeMount } from 'vue';

import ScholarshipForm from '@/presentation/components/scholarship-form/scholarship-form.vue';
import ScholarshipEditorCode from './scholarship-editor.class';

export default defineComponent({
	components: {
		ScholarshipForm,
	},

	setup: () => {
		const code = new ScholarshipEditorCode();

		onBeforeMount(() => code.beforeMount());
		onMounted(() => code.mounted());

		return {
			...code,
		};
	},
});
